'use strict';

export const COUNTRY_OPTIONS = {
    "US": {
        "display": "United States",
        "value": "US"
    },
    "AF": {
        "display": "Afghanistan",
        "value": "AF"
    },
    "AX": {
        "display": "Aland Islands",
        "value": "AX"
    },
    "AL": {
        "display": "Albania",
        "value": "AL"
    },
    "DZ": {
        "display": "Algeria",
        "value": "DZ"
    },
    "AD": {
        "display": "Andorra",
        "value": "AD"
    },
    "AO": {
        "display": "Angola",
        "value": "AO"
    },
    "AI": {
        "display": "Anguilla",
        "value": "AI"
    },
    "AG": {
        "display": "Antigua and Barbuda",
        "value": "AG"
    },
    "AR": {
        "display": "Argentina",
        "value": "AR"
    },
    "AM": {
        "display": "Armenia",
        "value": "AM"
    },
    "AW": {
        "display": "Aruba",
        "value": "AW"
    },
    "AU": {
        "display": "Australia",
        "value": "AU"
    },
    "AT": {
        "display": "Austria",
        "value": "AT"
    },
    "AZ": {
        "display": "Azerbaijan",
        "value": "AZ"
    },
    "BS": {
        "display": "Bahamas",
        "value": "BS"
    },
    "BH": {
        "display": "Bahrain",
        "value": "BH"
    },
    "BD": {
        "display": "Bangladesh",
        "value": "BD"
    },
    "BB": {
        "display": "Barbados",
        "value": "BB"
    },
    "BY": {
        "display": "Belarus",
        "value": "BY"
    },
    "BE": {
        "display": "Belgium",
        "value": "BE"
    },
    "BZ": {
        "display": "Belize",
        "value": "BZ"
    },
    "BJ": {
        "display": "Benin",
        "value": "BJ"
    },
    "BM": {
        "display": "Bermuda",
        "value": "BM"
    },
    "BT": {
        "display": "Bhutan",
        "value": "BT"
    },
    "BO": {
        "display": "Bolivia",
        "value": "BO"
    },
    "BA": {
        "display": "Bosnia and Herzegovina",
        "value": "BA"
    },
    "BW": {
        "display": "Botswana",
        "value": "BW"
    },
    "BV": {
        "display": "Bouvet Island",
        "value": "BV"
    },
    "BR": {
        "display": "Brazil",
        "value": "BR"
    },
    "IO": {
        "display": "British Indian Ocean Territory",
        "value": "IO"
    },
    "BN": {
        "display": "Brunei Darussalam",
        "value": "BN"
    },
    "BG": {
        "display": "Bulgaria",
        "value": "BG"
    },
    "BF": {
        "display": "Burkina Faso",
        "value": "BF"
    },
    "BI": {
        "display": "Burundi",
        "value": "BI"
    },
    "KH": {
        "display": "Cambodia",
        "value": "KH"
    },
    "CM": {
        "display": "Cameroon",
        "value": "CM"
    },
    "CA": {
        "display": "Canada",
        "value": "CA"
    },
    "CV": {
        "display": "Cape Verde",
        "value": "CV"
    },
    "BQ": {
        "display": "Caribbean Netherlands ",
        "value": "BQ"
    },
    "KY": {
        "display": "Cayman Islands",
        "value": "KY"
    },
    "CF": {
        "display": "Central African Republic",
        "value": "CF"
    },
    "TD": {
        "display": "Chad",
        "value": "TD"
    },
    "CL": {
        "display": "Chile",
        "value": "CL"
    },
    "CN": {
        "display": "China",
        "value": "CN"
    },
    "CX": {
        "display": "Christmas Island",
        "value": "CX"
    },
    "CC": {
        "display": "Cocos (Keeling) Islands",
        "value": "CC"
    },
    "CO": {
        "display": "Colombia",
        "value": "CO"
    },
    "KM": {
        "display": "Comoros",
        "value": "KM"
    },
    "CG": {
        "display": "Congo",
        "value": "CG"
    },
    "CD": {
        "display": "Congo, Democratic Republic of",
        "value": "CD"
    },
    "CK": {
        "display": "Cook Islands",
        "value": "CK"
    },
    "CR": {
        "display": "Costa Rica",
        "value": "CR"
    },
    "CI": {
        "display": "Cote D'Ivoire",
        "value": "CI"
    },
    "HR": {
        "display": "Croatia",
        "value": "HR"
    },
    "CU": {
        "display": "Cuba",
        "value": "CU"
    },
    "CW": {
        "display": "Curacao",
        "value": "CW"
    },
    "CY": {
        "display": "Cyprus",
        "value": "CY"
    },
    "CZ": {
        "display": "Czech Republic",
        "value": "CZ"
    },
    "DK": {
        "display": "Denmark",
        "value": "DK"
    },
    "DJ": {
        "display": "Djibouti",
        "value": "DJ"
    },
    "DM": {
        "display": "Dominica",
        "value": "DM"
    },
    "DO": {
        "display": "Dominican Republic",
        "value": "DO"
    },
    "EC": {
        "display": "Ecuador",
        "value": "EC"
    },
    "EG": {
        "display": "Egypt",
        "value": "EG"
    },
    "SV": {
        "display": "El Salvador",
        "value": "SV"
    },
    "GQ": {
        "display": "Equatorial Guinea",
        "value": "GQ"
    },
    "ER": {
        "display": "Eritrea",
        "value": "ER"
    },
    "EE": {
        "display": "Estonia",
        "value": "EE"
    },
    "ET": {
        "display": "Ethiopia",
        "value": "ET"
    },
    "FK": {
        "display": "Falkland Islands",
        "value": "FK"
    },
    "FO": {
        "display": "Faroe Islands",
        "value": "FO"
    },
    "FJ": {
        "display": "Fiji",
        "value": "FJ"
    },
    "FI": {
        "display": "Finland",
        "value": "FI"
    },
    "FR": {
        "display": "France",
        "value": "FR"
    },
    "GF": {
        "display": "French Guiana",
        "value": "GF"
    },
    "PF": {
        "display": "French Polynesia",
        "value": "PF"
    },
    "TF": {
        "display": "French Southern Territories",
        "value": "TF"
    },
    "GA": {
        "display": "Gabon",
        "value": "GA"
    },
    "GM": {
        "display": "Gambia",
        "value": "GM"
    },
    "GE": {
        "display": "Georgia",
        "value": "GE"
    },
    "DE": {
        "display": "Germany",
        "value": "DE"
    },
    "GH": {
        "display": "Ghana",
        "value": "GH"
    },
    "GI": {
        "display": "Gibraltar",
        "value": "GI"
    },
    "GR": {
        "display": "Greece",
        "value": "GR"
    },
    "GL": {
        "display": "Greenland",
        "value": "GL"
    },
    "GD": {
        "display": "Grenada",
        "value": "GD"
    },
    "GP": {
        "display": "Guadeloupe",
        "value": "GP"
    },
    "GT": {
        "display": "Guatemala",
        "value": "GT"
    },
    "GG": {
        "display": "Guernsey",
        "value": "GG"
    },
    "GN": {
        "display": "Guinea",
        "value": "GN"
    },
    "GW": {
        "display": "Guinea-Bissau",
        "value": "GW"
    },
    "GY": {
        "display": "Guyana",
        "value": "GY"
    },
    "HT": {
        "display": "Haiti",
        "value": "HT"
    },
    "HM": {
        "display": "Heard and McDonald Islands",
        "value": "HM"
    },
    "HN": {
        "display": "Honduras",
        "value": "HN"
    },
    "HK": {
        "display": "Hong Kong",
        "value": "HK"
    },
    "HU": {
        "display": "Hungary",
        "value": "HU"
    },
    "IS": {
        "display": "Iceland",
        "value": "IS"
    },
    "IN": {
        "display": "India",
        "value": "IN"
    },
    "ID": {
        "display": "Indonesia",
        "value": "ID"
    },
    "IR": {
        "display": "Iran",
        "value": "IR"
    },
    "IQ": {
        "display": "Iraq",
        "value": "IQ"
    },
    "IE": {
        "display": "Ireland",
        "value": "IE"
    },
    "IM": {
        "display": "Isle of Man",
        "value": "IM"
    },
    "IL": {
        "display": "Israel",
        "value": "IL"
    },
    "IT": {
        "display": "Italy",
        "value": "IT"
    },
    "JM": {
        "display": "Jamaica",
        "value": "JM"
    },
    "JP": {
        "display": "Japan",
        "value": "JP"
    },
    "JE": {
        "display": "Jersey",
        "value": "JE"
    },
    "JO": {
        "display": "Jordan",
        "value": "JO"
    },
    "KZ": {
        "display": "Kazakhstan",
        "value": "KZ"
    },
    "KE": {
        "display": "Kenya",
        "value": "KE"
    },
    "KI": {
        "display": "Kiribati",
        "value": "KI"
    },
    "KW": {
        "display": "Kuwait",
        "value": "KW"
    },
    "KG": {
        "display": "Kyrgyzstan",
        "value": "KG"
    },
    "LA": {
        "display": "Lao People's Democratic Republic",
        "value": "LA"
    },
    "LV": {
        "display": "Latvia",
        "value": "LV"
    },
    "LB": {
        "display": "Lebanon",
        "value": "LB"
    },
    "LS": {
        "display": "Lesotho",
        "value": "LS"
    },
    "LR": {
        "display": "Liberia",
        "value": "LR"
    },
    "LY": {
        "display": "Libya",
        "value": "LY"
    },
    "LI": {
        "display": "Liechtenstein",
        "value": "LI"
    },
    "LT": {
        "display": "Lithuania",
        "value": "LT"
    },
    "LU": {
        "display": "Luxembourg",
        "value": "LU"
    },
    "MO": {
        "display": "Macau",
        "value": "MO"
    },
    "MK": {
        "display": "Macedonia",
        "value": "MK"
    },
    "MG": {
        "display": "Madagascar",
        "value": "MG"
    },
    "MW": {
        "display": "Malawi",
        "value": "MW"
    },
    "MY": {
        "display": "Malaysia",
        "value": "MY"
    },
    "MV": {
        "display": "Maldives",
        "value": "MV"
    },
    "ML": {
        "display": "Mali",
        "value": "ML"
    },
    "MT": {
        "display": "Malta",
        "value": "MT"
    },
    "MQ": {
        "display": "Martinique",
        "value": "MQ"
    },
    "MR": {
        "display": "Mauritania",
        "value": "MR"
    },
    "MU": {
        "display": "Mauritius",
        "value": "MU"
    },
    "YT": {
        "display": "Mayotte",
        "value": "YT"
    },
    "MX": {
        "display": "Mexico",
        "value": "MX"
    },
    "MD": {
        "display": "Moldova",
        "value": "MD"
    },
    "MC": {
        "display": "Monaco",
        "value": "MC"
    },
    "MN": {
        "display": "Mongolia",
        "value": "MN"
    },
    "ME": {
        "display": "Montenegro",
        "value": "ME"
    },
    "MS": {
        "display": "Montserrat",
        "value": "MS"
    },
    "MA": {
        "display": "Morocco",
        "value": "MA"
    },
    "MZ": {
        "display": "Mozambique",
        "value": "MZ"
    },
    "MM": {
        "display": "Myanmar",
        "value": "MM"
    },
    "NA": {
        "display": "Namibia",
        "value": "NA"
    },
    "NR": {
        "display": "Nauru",
        "value": "NR"
    },
    "NP": {
        "display": "Nepal",
        "value": "NP"
    },
    "NC": {
        "display": "New Caledonia",
        "value": "NC"
    },
    "NZ": {
        "display": "New Zealand",
        "value": "NZ"
    },
    "NI": {
        "display": "Nicaragua",
        "value": "NI"
    },
    "NE": {
        "display": "Niger",
        "value": "NE"
    },
    "NG": {
        "display": "Nigeria",
        "value": "NG"
    },
    "NU": {
        "display": "Niue",
        "value": "NU"
    },
    "NF": {
        "display": "Norfolk Island",
        "value": "NF"
    },
    "KP": {
        "display": "North Korea",
        "value": "KP"
    },
    "NO": {
        "display": "Norway",
        "value": "NO"
    },
    "OM": {
        "display": "Oman",
        "value": "OM"
    },
    "PK": {
        "display": "Pakistan",
        "value": "PK"
    },
    "PS": {
        "display": "Palestinian Territory, Occupied",
        "value": "PS"
    },
    "PA": {
        "display": "Panama",
        "value": "PA"
    },
    "PG": {
        "display": "Papua New Guinea",
        "value": "PG"
    },
    "PY": {
        "display": "Paraguay",
        "value": "PY"
    },
    "PE": {
        "display": "Peru",
        "value": "PE"
    },
    "PH": {
        "display": "Philippines",
        "value": "PH"
    },
    "PN": {
        "display": "Pitcairn",
        "value": "PN"
    },
    "PL": {
        "display": "Poland",
        "value": "PL"
    },
    "PT": {
        "display": "Portugal",
        "value": "PT"
    },
    "QA": {
        "display": "Qatar",
        "value": "QA"
    },
    "RE": {
        "display": "Reunion",
        "value": "RE"
    },
    "RO": {
        "display": "Romania",
        "value": "RO"
    },
    "RU": {
        "display": "Russian Federation",
        "value": "RU"
    },
    "RW": {
        "display": "Rwanda",
        "value": "RW"
    },
    "BL": {
        "display": "Saint Barthelemy",
        "value": "BL"
    },
    "SH": {
        "display": "Saint Helena",
        "value": "SH"
    },
    "KN": {
        "display": "Saint Kitts and Nevis",
        "value": "KN"
    },
    "LC": {
        "display": "Saint Lucia",
        "value": "LC"
    },
    "VC": {
        "display": "Saint Vincent and the Grenadines",
        "value": "VC"
    },
    "MF": {
        "display": "Saint-Martin (France)",
        "value": "MF"
    },
    "SX": {
        "display": "Saint-Martin (Pays-Bas)",
        "value": "SX"
    },
    "WS": {
        "display": "Samoa",
        "value": "WS"
    },
    "SM": {
        "display": "San Marino",
        "value": "SM"
    },
    "ST": {
        "display": "Sao Tome and Principe",
        "value": "ST"
    },
    "SA": {
        "display": "Saudi Arabia",
        "value": "SA"
    },
    "SN": {
        "display": "Senegal",
        "value": "SN"
    },
    "RS": {
        "display": "Serbia",
        "value": "RS"
    },
    "SC": {
        "display": "Seychelles",
        "value": "SC"
    },
    "SL": {
        "display": "Sierra Leone",
        "value": "SL"
    },
    "SG": {
        "display": "Singapore",
        "value": "SG"
    },
    "SK": {
        "display": "Slovakia (Slovak Republic)",
        "value": "SK"
    },
    "SI": {
        "display": "Slovenia",
        "value": "SI"
    },
    "SB": {
        "display": "Solomon Islands",
        "value": "SB"
    },
    "SO": {
        "display": "Somalia",
        "value": "SO"
    },
    "ZA": {
        "display": "South Africa",
        "value": "ZA"
    },
    "GS": {
        "display": "South Georgia & S Sandwich Islands",
        "value": "GS"
    },
    "KR": {
        "display": "South Korea",
        "value": "KR"
    },
    "SS": {
        "display": "South Sudan",
        "value": "SS"
    },
    "ES": {
        "display": "Spain",
        "value": "ES"
    },
    "LK": {
        "display": "Sri Lanka",
        "value": "LK"
    },
    "PM": {
        "display": "St. Pierre and Miquelon",
        "value": "PM"
    },
    "SD": {
        "display": "Sudan",
        "value": "SD"
    },
    "SR": {
        "display": "Suriname",
        "value": "SR"
    },
    "SJ": {
        "display": "Svalbard and Jan Mayen Islands",
        "value": "SJ"
    },
    "SZ": {
        "display": "Swaziland",
        "value": "SZ"
    },
    "SE": {
        "display": "Sweden",
        "value": "SE"
    },
    "CH": {
        "display": "Switzerland",
        "value": "CH"
    },
    "SY": {
        "display": "Syria",
        "value": "SY"
    },
    "TW": {
        "display": "Taiwan",
        "value": "TW"
    },
    "TJ": {
        "display": "Tajikistan",
        "value": "TJ"
    },
    "TZ": {
        "display": "Tanzania",
        "value": "TZ"
    },
    "TH": {
        "display": "Thailand",
        "value": "TH"
    },
    "NL": {
        "display": "The Netherlands",
        "value": "NL"
    },
    "TL": {
        "display": "Timor-Leste",
        "value": "TL"
    },
    "TG": {
        "display": "Togo",
        "value": "TG"
    },
    "TK": {
        "display": "Tokelau",
        "value": "TK"
    },
    "TO": {
        "display": "Tonga",
        "value": "TO"
    },
    "TT": {
        "display": "Trinidad and Tobago",
        "value": "TT"
    },
    "TN": {
        "display": "Tunisia",
        "value": "TN"
    },
    "TR": {
        "display": "Turkey",
        "value": "TR"
    },
    "TM": {
        "display": "Turkmenistan",
        "value": "TM"
    },
    "TC": {
        "display": "Turks and Caicos Islands",
        "value": "TC"
    },
    "TV": {
        "display": "Tuvalu",
        "value": "TV"
    },
    "UG": {
        "display": "Uganda",
        "value": "UG"
    },
    "UA": {
        "display": "Ukraine",
        "value": "UA"
    },
    "AE": {
        "display": "United Arab Emirates",
        "value": "AE"
    },
    "GB": {
        "display": "United Kingdom",
        "value": "GB"
    },
    "UM": {
        "display": "United States Minor Outlying Islands",
        "value": "UM"
    },
    "VI": {
        "display": "United States Virgin Islands",
        "value": "VI"
    },
    "UY": {
        "display": "Uruguay",
        "value": "UY"
    },
    "UZ": {
        "display": "Uzbekistan",
        "value": "UZ"
    },
    "VU": {
        "display": "Vanuatu",
        "value": "VU"
    },
    "VA": {
        "display": "Vatican",
        "value": "VA"
    },
    "VE": {
        "display": "Venezuela",
        "value": "VE"
    },
    "VN": {
        "display": "Vietnam",
        "value": "VN"
    },
    "VG": {
        "display": "Virgin Islands (British)",
        "value": "VG"
    },
    "WF": {
        "display": "Wallis and Futuna Islands",
        "value": "WF"
    },
    "YE": {
        "display": "Yemen",
        "value": "YE"
    },
    "ZM": {
        "display": "Zambia",
        "value": "ZM"
    },
    "ZW": {
        "display": "Zimbabwe",
        "value": "ZW"
    }
};
